/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable react/require-default-props */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-return-await */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable no-shadow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import AWS from 'aws-sdk';
import { toast } from 'react-toastify';
import { Page } from 'react-pdf';
import moment from 'utils/moment';
import styles from '../badging.module.scss';
import Panel from '../../../components/panel';
import Button from '../../../components/button/button';
import { GetFileName, S3Uploads } from '../../services';
import { getField, getS3Region } from '../../../utils/helpers';
import { isLocal, hostName } from '../../../constants/apiEnv';
import Loading from '../../../components/loading';
import DisplayPDF from './DisplayPDF';
import ProgressBar from '../../sms/components/ProgressBar';
import Step0 from './Components/Step0';
import Step1 from './Components/Step1';
import Modal from '../../../components/modal';
import Step2 from './Components/Step2';

const url = hostName.slice(6);

class ApplicationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: { attachments_listA: [], attachments_listB: [], attachments_listC: [], feet: '', inches: '', terms: false },
      answers: {},
      requiredMap: {},
      fieldErrors: {
        first_name: true,
        last_name: true,
        email: true,
        phone_number: true,
        attachmentslist_a: false,
        attachmentslist_b: false,
        attachmentslist_c: false,
        signature: false
      },
      removedAttachments: [],
      removedAttachments_A: [],
      removedAttachments_B: [],
      removedAttachments_C: [],
      listAValues: [],
      listBValues: [],
      listCValues: [],
      requiredAttachments: {},
      requiredAttachmentsErrors: {},
      response: {
        nation_of_citizenship: { value: 'US', label: 'United States' }
      },
      showFormErrors: false,
      loadingStatus: false,
      currentStep: 0,
      signatureFields: [],
      additional_info: [
        {
          multipleRemarks: {},
          felonyInvolvingRemarks: {},
          noneCheckbox: false,
          agreements: {},
          checkedMultipleValues: {},
          felonyCheckedValues: {}
        }
      ],
      successMessage: '',
      showIn: true,
      privacyMessage: '',
      listAError: false,
      listBError: false,
      listAMessage: '',
      listBMessage: '',
      listCMessage: '',
      applicantAcknowldgementMessage: '',
      numPages: null,
      loading: true,
      dateError: false,
      checkboxSectionError: false
    };
    const { match: { params: { installationId } } } = props;
    this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${installationId}${url}/public`;
    // this.publicUrl = `https://apis.us.dev.aerosimple.com/public`;

    this.wrapperRef = React.createRef();
    this.ActionsRef = React.createRef();
    this.slideStyles = {
      entered: { transform: 'translate3d(0px,0px)' }
    };
  }

  async componentDidMount() {
    const { airportCode, id, phone, otp, form, renewalApplicationData } = this.props;
    const hostURL = window.location.hostname.replace(/^.{6}/g, 'us');
    try {
      this.setState({ loadingStatus: true });
      const data = {};
      data.phone = phone[0] + phone.slice(1).replace(/[^\d]/g, '');
      data.otp = otp;
      this.getConfig();
      this.getData(form?.settings?.success_message_attachment);
      this.getPrivacyMessageData(form?.settings?.privacy_message_attachment);
      this.getListAMessageData(form?.settings?.list_a_documents);
      this.getListBMessageData(form?.settings?.list_b_documents);
      this.getListCMessageData(form?.settings?.list_c_documents);
      this.getApplicantAcknowldgementMessageData(form?.settings?.applicant_acknowledgement);
      await fetch(`${this.publicUrl}/badging/badge/${id}/${airportCode}`)
        .then(response => response.json())
        .then((data) => {
          let requiredMap = {};
          let fieldErrors = {};
          let conditionalFields = {};
          const attachmentFields = [];
          const signatureFields = [];
          const fields = data?.answer_schema?.fields.filter(field => (
            field?.internal !== true && field?.settings?.disable_for_public !== true
          ));
          const app = data;
          const employerType = fields?.filter(fil => fil.id === 'employer');
          fields.forEach((detailField) => {
            const isDisabled = detailField.isDisabled || detailField?.settings?.disable_for_public || detailField?.internal;
            if (
              detailField.type !== 'dataSource'
              && detailField.type !== 'dataSourceMultiselect'
              && detailField.type !== 'header'
              && detailField.type !== 'attachments'
            ) {
              requiredMap = {
                ...requiredMap,
                [detailField.id]: isDisabled ? false : detailField.required
              };
              if (!detailField.conditional) {
                fieldErrors = {
                  ...this.state.fieldErrors,
                  ...fieldErrors,
                  [detailField.id]: isDisabled || Object.keys(detailField?.default_value || {})?.length !== 0
                  ? false
                  : detailField.required
                };
              } else if (!isDisabled) {
                conditionalFields[detailField?.conditional_field?.key] = [
                  ...(conditionalFields[detailField?.conditional_field?.key] || []),
                  detailField
                ];
              } else {
                fieldErrors = {
                  ...fieldErrors,
                  [detailField.id]: false
                };
              }
            }
          if (detailField.type === 'signature' && !detailField?.isDisabled) {
            signatureFields.push(detailField.id);
          }
          if (detailField.type === 'attachments') {
            attachmentFields.push(detailField.id);
          }
          });
          let responseWithDefaults = {};
          fields.forEach((field) => {
            if (
              field.default_value
              && Object.keys(field.default_value).length > 0
            ) {
              if (field.type === 'select' && field.values) {
                responseWithDefaults[field.id] = field.default_value.key;
              } else {
                responseWithDefaults[field.id] = field.default_value.key;
              }
            }
          });
          this.setState({
            publicFiledValidations: data.public_attributes||{},
            application: data,
            fields,
            requiredMap,
            fieldErrors,
            loadingStatus: false,
            attachmentFields,
            conditionalFields,
            app,
            signatureFields,
            response: {
              ...responseWithDefaults,
              nation_of_citizenship: { value: 'US', label: 'United States' },
              // eslint-disable-next-line no-nested-ternary, max-len
              employer: (employerType && Object.keys(employerType).length > 0 && employerType[0].type === 'select') ? { value: app?.company_name?.id, label: app?.company_name?.name } : renewalApplicationData !== undefined ? app.company_name : app.company_name?.name
            }
          });
        });
    } catch (error) {
      let message = 'There was a problem while retrieving the form';
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
    }
    if (this.state.pdfUrl === '') {
      try {
        await fetch(`https://static.${hostURL}/media/badging/demo_doc/${airportCode}.pdf`)
          .then((response) => {
            this.setState({
              pdfUrl: response
            });
          });
      } catch (error) {
        this.setState({
          loadingStatus: false
        });
      }
    }
    if (renewalApplicationData !== undefined) {
      const height = renewalApplicationData?.response?.height;
      const [feet, inches] = height.split("'").map(str => parseInt(str, 10));
      this.setState({
        info: {
          ...this.state.info,
          feet,
          inches,
          attachments_listA: renewalApplicationData?.attachments_listA,
          attachments_listB: renewalApplicationData?.attachments_listB,
          attachments_listC: renewalApplicationData?.attachments_listC,
          terms: true
        },
        app: renewalApplicationData,
        createApiStatus: false,
        signatureFields: ['signature'],
        response: {
          ...this.state.response,
          signature: []
        },
        fieldErrors: {
          signature: true
        },
        application: renewalApplicationData,
        additional_info: renewalApplicationData?.additional_info
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { handleBadgeStatus, form, renewalApplicationData } = this.props;
    const { app, info, createApiStatus } = this.state;
    if (form && form?.settings.length > 0) {
      this.getListAMessageData(form?.settings?.list_a_documents);
      this.getListBMessageData(form?.settings?.list_b_documents);
      this.getListCMessageData(form?.settings?.list_c_documents);
      this.getApplicantAcknowldgementMessageData(form?.settings?.applicant_acknowledgement);
    }
    if (createApiStatus=== true || (app && (app.status !== 3 && app.status !== 0 && app.status !== 4 && app.status !== 2) && app.current_stage !=='initiated')) {
      handleBadgeStatus({ 'info': info, 'successMessage': this.state.successMessage });
    } else {
      localStorage.removeItem('currentPage');
    }
    if (app!==prevState.app) {
      let thefieldErrors = {};
      const bool = true;
      if (app.response) {
        Object.entries(app.response).forEach(([key, value]) => {
          thefieldErrors = {
            ...thefieldErrors,
            [key]: value ? !bool : bool
          };
        });
      }
      const employerType = app.answer_schema.fields?.filter(fil => fil.id === 'employer');
      const signatureType = app.answer_schema.fields?.filter(fil => fil.id === 'signature' && !fil?.isDisabled);

          const attachmentslistA = getField(app.answer_schema.fields, 'attachmentslist_a');
          const attachmentslistB = getField(app.answer_schema.fields, 'attachmentslist_b');
          const attachmentslistC = getField(app.answer_schema.fields, 'attachmentslist_c');

          const minofDocsA = attachmentslistA?.settings?.min_no_of_reqDocs;
          const minofDocsB = attachmentslistB?.settings?.min_no_of_reqDocs;
          const minofDocsC = attachmentslistC?.settings?.min_no_of_reqDocs;
          const listAValues = Object.keys(attachmentslistA?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistA?.settings?.req_docs?.[e] }));
          const listBValues = Object.keys(attachmentslistB?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistB?.settings?.req_docs?.[e] }));
          const listCValues = Object.keys(attachmentslistC?.settings?.req_docs|| {})?.map(e => ({ key: `${e}`, value: attachmentslistC?.settings?.req_docs?.[e] }));

          let reqAttachments = {};
          let reqAttachmentsErrors = {};

          const updateReqAttachments = () => {
            const attachments_listA = {};
            const attachments_listB = {};
            const attachments_listC = {};
            const listAErrors = {};
            const listBErrors = {};
            const listCErrors = {};

            if (app?.status ===4) {
              let dateFormat = localStorage.getItem('dateFormat') || 'DD/MM/YYYY';

              const editData = app;
              if (attachmentslistA?.settings?.add_req_docs) {
              Object.keys(editData?.forms_of_identification?.attachments_listA || {}).forEach((eachRow) => {
                const { file_name = '', attachment = [], expiry_date = '' } = editData?.forms_of_identification?.attachments_listA?.[eachRow] || {};

                attachments_listA[eachRow] = {
                  file_name: editData?.status!==7 ? file_name?.key :'',
                  ...(attachmentslistB?.settings?.add_expiration && editData?.status!==7 ?{ expiry_date } : { expiry_date: moment(new Date()).format(dateFormat) }),
                  attachment: editData?.status!==7 ?editData?.attachments_listA?.filter(each => attachment.includes(each.attachment_id)) : []
                };

                listAErrors[eachRow] = {
                  file_name: attachmentslistA?.required && editData?.status!==7? !Object.keys(file_name || {}).length>0 :false,
                  ...(editData?.settings?.add_expiration && { expiry_date: attachmentslistA?.required ? !expiry_date?.length>0 : false }),
                  attachment: attachmentslistA?.required ? !attachment?.length>0 : false
                };
              });
              }

              if (attachmentslistB?.settings?.add_req_docs) {
              Object.keys(editData?.forms_of_identification?.attachments_listB || {}).forEach((eachRow) => {
                const { file_name = '', attachment = [], expiry_date = '' } = editData?.forms_of_identification?.attachments_listB?.[eachRow] || {};

                attachments_listB[eachRow] = {
                  file_name: editData?.status!==7 ? file_name?.key : '',
                  ...(attachmentslistB?.settings?.add_expiration && editData?.status!==7 ?{ expiry_date } : { expiry_date: moment(new Date()).format(dateFormat) }),
                  attachment: editData?.status!==7 ? editData?.attachments_listB.filter(each => attachment.includes(each.attachment_id)) :[]
                };

                listBErrors[eachRow] = {
                  file_name: attachmentslistB?.required && editData?.status!==7 ? !Object.keys(file_name || {}).length>0 :false,
                  ...(attachmentslistB?.settings?.add_expiration && { expiry_date: attachmentslistB?.required ? !expiry_date?.length>0 : false }),
                  attachment: attachmentslistB.required && editData?.status!==7 ? !attachment?.length>0 : false
                };
              });
              }
              if (attachmentslistC?.settings?.add_req_docs) {
                Object.keys(editData?.forms_of_identification?.attachments_listC || {}).forEach((eachRow) => {
                  const { file_name = '', attachment = [], expiry_date = '' } = editData?.forms_of_identification?.attachments_listC?.[eachRow] || {};

                  attachments_listC[eachRow] = {
                    file_name: editData?.status!==7 ? file_name?.key : '',
                    ...(attachmentslistC?.settings?.add_expiration && editData?.status!==7 ?{ expiry_date } : { expiry_date: moment(new Date()).format(dateFormat) }),
                    attachment: editData?.status!==7 ? editData?.attachments_listC.filter(each => attachment.includes(each.attachment_id)) :[]
                  };

                  listCErrors[eachRow] = {
                    file_name: attachmentslistC?.required && editData?.status!==7 ? !Object.keys(file_name || {}).length>0 :false,
                    ...(attachmentslistC?.settings?.add_expiration && { expiry_date: attachmentslistC?.required ? !expiry_date?.length>0 : false }),
                    attachment: attachmentslistC.required && editData?.status!==7 ? !attachment?.length>0 : false
                  };
                });
              }
            } else {
              if (attachmentslistA?.settings?.add_req_docs) {
              for (let i = 0; i < minofDocsA; i++) {
                const rowKey = `row_${i}`;
                attachments_listA[rowKey] = {
                  file_name: '',
                  ...(attachmentslistA?.settings?.add_expiration && { expiry_date: '' }),
                  attachment: []
                };

                listAErrors[rowKey] = {
                  file_name: attachmentslistA.required,
                    ...(attachmentslistA?.settings?.add_expiration && { expiry_date: attachmentslistA.required }),
                    attachment: attachmentslistA.required
                  };
              }
              }

              if (attachmentslistB?.settings?.add_req_docs) {
              for (let i = 0; i < minofDocsB; i++) {
                const rowKey = `row_${i}`;

                attachments_listB[rowKey] = {
                  file_name: '',
                  ...(attachmentslistB?.settings?.add_expiration && { expiry_date: '' }),
                  attachment: []
                };

                listBErrors[rowKey] = {
                  file_name: attachmentslistB.required,
                  ...(attachmentslistB?.settings?.add_expiration && { expiry_date: attachmentslistB.required }),
                  attachment: attachmentslistB.required
                };
              }
              }
              if (attachmentslistC?.settings?.add_req_docs) {
                for (let i = 0; i < minofDocsC; i++) {
                  const rowKey = `row_${i}`;

                  attachments_listC[rowKey] = {
                    file_name: '',
                    ...(attachmentslistC?.settings?.add_expiration && { expiry_date: '' }),
                    attachment: []
                  };

                  listCErrors[rowKey] = {
                    file_name: attachmentslistC.required,
                    ...(attachmentslistC?.settings?.add_expiration && { expiry_date: attachmentslistC.required }),
                    attachment: attachmentslistC.required
                  };
                }
              }
              }

            reqAttachments.attachments_listA = attachments_listA;
            reqAttachments.attachments_listB = attachments_listB;
            reqAttachments.attachments_listC = attachments_listC;

            reqAttachmentsErrors.attachments_listA = listAErrors;
            reqAttachmentsErrors.attachments_listB = listBErrors;
            reqAttachmentsErrors.attachments_listC = listCErrors;

            return reqAttachments;
          };

        updateReqAttachments();
        const badgeFields = app?.answer_schema?.fields.filter(field => (
          field?.internal !== true && field?.settings?.disable_for_public !== true
        ));
        let responseWithDefaults = { ...app?.response };
        badgeFields.forEach((field) => {
          if (
            field.default_value
            && Object.keys(field.default_value).length > 0
            && !responseWithDefaults[field.id]
          ) {
            if (field.type === 'select' && field.values) {
              responseWithDefaults[field.id] = field.default_value.key;
            } else {
              responseWithDefaults[field.id] = field.default_value.key;
            }
            }
        });
      this.setState({
        info: {
          ...this.state.info,
          first_name: app.first_name,
          last_name: app.last_name,
          suffix: app.suffix,
          email: app.email,
          phone_number: app.phone_number,
          attachments_listA: app.attachments_listA,
          attachments_listB: app.attachments_listB,
          attachments_listC: app.attachments_listC
        },
        // response:{...app?.response},
        response: {
          ...responseWithDefaults,
          nation_of_citizenship: app.response?.nation_of_citizenship ? app.response?.nation_of_citizenship : { value: 'US', label: 'United States' },
          street: app.response?.street,
          // eslint-disable-next-line max-len, no-nested-ternary
          employer: (employerType && Object.keys(employerType).length > 0 && employerType[0].type === 'select') ? { value: app?.company_name?.id, label: app?.company_name?.name } : renewalApplicationData !== undefined ? app.company_name : app?.company_name?.name,
          signature: (signatureType && Object.keys(signatureType).length > 0 && signatureType[0].type === 'signature') ? [] : ''
        },
        additional_info: app.additional_info.length > 0 ? app.additional_info : this.state.additional_info,
        fields: badgeFields,
        requiredAttachmentsErrors: reqAttachmentsErrors,
        requiredAttachments: reqAttachments,
        listAValues,
        listBValues,
        listCValues,
        fieldErrors: {
          first_name: app?.first_name ? false:true,
          last_name: app?.last_name ? false:true,
          email: app?.email ? false:true,
          phone_number: app?.phone_number ? false:true,
          employer: app.company_name ? false : true,
          attachmentslist_a: false,
          attachmentslist_b: false,
          attachmentslist_c: false,
          ...thefieldErrors
        }
      });
      this.processInspectionForState(app);
    }
  }

    handleAnswerChanged = (section, answer, fieldId, type, value) => {
      const { fields } = this.state;
      const { response, fieldErrors, info, conditionalFields, requiredAttachments } = this.state;
      const getAttachment = id => fields?.find(f => f.id === id)?.settings;
      const a_attachment = getAttachment('attachmentslist_a');
      const b_attachment = getAttachment('attachmentslist_b');
      const c_attachment = getAttachment('attachmentslist_c');
      const streetType = fields?.find(f => f.id === 'street');
      if (fieldId === 'attachments_listA' && type) {
        this.setState(prevState => ({
          ...prevState,
          fieldErrors: {
            ...prevState.fieldErrors,
            attachmentslist_a: !answer.length>0
          }
        }));
      }
      if (fieldId === 'attachments_listB' && type) {
        this.setState(prevState => ({
          ...prevState,
          fieldErrors: {
            ...prevState.fieldErrors,
            attachmentslist_b: !answer.length>0
          }
        }));
      }
      if (fieldId === 'attachments_listC' && type) {
        this.setState(prevState => ({
          ...prevState,
          fieldErrors: {
            ...prevState.fieldErrors,
            attachmentslist_c: !answer.length>0
          }
        }));
      }
      if (fieldId==='street'&& streetType?.type === 'address') {
        this.setState({
          response: {
            ...response,
            street: answer.street,
            state: answer.state,
            city: answer.city,
            zip: answer.zip,
            country: answer.country
            ? { label: answer.country?.label, value: answer.country?.value }
            : response.country
          },
          fieldErrors: {
            ...fieldErrors,
            street: !answer.street,
            city: !answer.city,
            state: !answer.state,
            country: answer.country
            ? !(answer.country?.label && answer.country?.value)
            : fieldErrors.country,
            zip: !answer.zip
          }
        });
      }
      if (fieldId === 'feet') {
        this.setState({
          info: {
            ...info,
            feet: answer
          },
          response: {
            ...response,
            height: answer
          }
        });
      }
      if (fieldId === 'inches') {
        this.setState({
          info: {
            ...info,
            inches: answer
          },
          response: {
            ...response,
            height: `${this.state.info?.feet}'${answer}`
          },
          fieldErrors: {
            ...fieldErrors,
            height: false
          }
        });
      }
      if (fieldId==='employer_address') {
        this.setState({ response: { ...response, employer_address: answer.fulladdress } });
      }
      if (type ==='isCheckbox') {
        let additional_info = this.state.additional_info;
        additional_info[0].multipleRemarks[fieldId] = answer;
        this.setState({ additional_info });
      } else if (type ==='subCheckbox') {
        let additional_info = this.state.additional_info;
        additional_info[0].felonyInvolvingRemarks[fieldId] = answer;
        this.setState({ additional_info });
      } else if (type === 'agreements') {
        let additional_info = this.state.additional_info;
        additional_info[0].agreements[fieldId] = answer;
        this.setState({ additional_info });
      }
      if (type === 'isCheckbox' || type === 'subCheckbox') {
        if (Object.values(this.state.additional_info[0]?.multipleRemarks || []).includes(true) || Object.values(this.state.additional_info[0]?.felonyInvolvingRemarks || []).includes(true)) {
          let additional_info = this.state.additional_info;
          additional_info[0].noneCheckbox = false;
          this.setState({ additional_info });
        }
      }
      if (fieldId === 'noneCheckbox') {
        let additional_info = this.state.additional_info;
        additional_info[0].noneCheckbox = answer;
        this.setState({ additional_info });
      }
      if ((type === 'isCheckbox' || type === 'subCheckbox') || fieldId === 'noneCheckbox') {
        const check = Object.values(this.state.additional_info[0]?.multipleRemarks || []).includes(true) || Object.values(this.state.additional_info[0]?.felonyInvolvingRemarks || []).includes(true);
        if (check === true || (this.state.additional_info && this.state.additional_info[0]?.noneCheckbox === true)) {
          this.setState({ checkboxSectionError: false });
        } else {
        this.setState({ checkboxSectionError: true });
        }
      }
    if (section === 'requiredAttachments') {
      const attachmentsMap = {
        attachments_listA: a_attachment,
        attachments_listB: b_attachment,
        attachments_listC: c_attachment
      };
      const currentAttachment = attachmentsMap[type];
      // call solve once — ensure we always pass an array and a string
      const valid = this.solve(
        currentAttachment?.req_docs_for_validation ?? [], // array expected
        String(answer ?? '') // normalize answer
      );
      let error = false;
      let attachmentError = false;
      if (fieldId !== 'attachment') {
      const hasValue = String(answer ?? '').trim() !== '';
      const selectedCheck = hasValue && String(answer) === String(valid?.key);
      error = selectedCheck ? false : !hasValue;
      attachmentError = selectedCheck ? false : !!requiredAttachments?.[type]?.[value]?.attachment;
      } else if (answer?.length>0) {
        error = false;
      } else {
        error = true;
      }
      // update nested state immutably and log errors after update
      this.setState((prevState) => {
        const newRequiredAttachments = {
          ...prevState.requiredAttachments,
          [type]: {
            ...prevState.requiredAttachments?.[type],
            [value]: {
              ...prevState.requiredAttachments?.[type]?.[value],
              [fieldId]: answer
            }
          }
        };
        const newRequiredAttachmentsErrors = {
          ...prevState.requiredAttachmentsErrors,
          [type]: {
            ...prevState.requiredAttachmentsErrors?.[type],
            [value]: {
              ...prevState.requiredAttachmentsErrors?.[type]?.[value],
              attachment: attachmentError,
              [fieldId]: error
            }
          }
        };
        return {
          ...prevState,
          requiredAttachments: newRequiredAttachments,
          requiredAttachmentsErrors: newRequiredAttachmentsErrors
        };
      });
    }
      if (section !== 'additional_info' && section !== 'requiredAttachments') {
        this.setState(prevState => ({
          [section]: {
            ...prevState[section],
            [fieldId]: answer
          }
        }));
      }
      // Update validation for normal fields
      if (section === 'response') {
        const isRequired = this.state.requiredMap?.[fieldId];

        if (isRequired) {
          const hasValue = answer !== undefined
            && answer !== null
            && answer !== ''
            && !(typeof answer === 'object' && !answer.value);

          this.handleFieldErrorChanged(fieldId, !hasValue);
        }
      }

      // HANDLE CONDITIONAL FIELDS WITH FIELD ERRORS
      if (conditionalFields?.[fieldId]?.length) {
        conditionalFields[fieldId].map((item) => {
        const conditionValues = item?.conditional_values;
        let fieldValue = answer;
        let enabelCondition = false;
        if (typeof fieldValue === 'boolean') fieldValue = fieldValue.toString();
        enabelCondition = conditionValues.some(value => fieldValue === value?.value);
        if (item.required) {
          this.handleFieldErrorChanged(
            item.id,
            enabelCondition ? ![section]?.[item?.id] : false
          );
        }
        if (item?.type !== 'header') {
          if (enabelCondition) {
            this.setState(prevState => ({
              [section]: {
                ...prevState[section],
                [fieldId]: answer,
                [item.id]: prevState?.[section]?.[item.id] || (item?.type === 'boolean' ? false : '')
              }
            }));
          } else {
            this.setState(prevState => ({
              [section]: {
                ...prevState[section],
                [fieldId]: answer,
                [item.id]: item?.type === 'boolean' ? false : ''
              }
            }));
            if (item?.conditional) this.handleAnswerChanged('', item.id);
          }
        }
        return item;
      });
      }
    }

  solve = (request_validation, answer) => {
    const keys = Array.isArray(request_validation)
      ? request_validation.map(String)
      : [];
    const key = keys.includes(String(answer)) ? String(answer) : undefined;
    return { key };
  };

    handleFieldErrorChanged = (id, value) => {
      this.setState(prevState => ({
        ...prevState,
        fieldErrors: {
          ...prevState.fieldErrors,
          [id]: value
        }
      }));
    }

    handleUploadAttachments = async (attachments, entity) => {
      const attachmentIds = [];
      const newAttachments = [];
      const oldAttachments = [];
      attachments.forEach((e) => {
        if (!e.id) {
          newAttachments.push(e);
        } else if (e.id && e.name) {
          oldAttachments.push(e.name);
        }
      });
      let fileIds = '';
      if (newAttachments.length > 0) {
        fileIds = await GetFileName.getUploadFileName(newAttachments?.length);
      }
      if (fileIds) {
        await S3Uploads.uploadFiles(
          newAttachments,
          fileIds.filename,
          entity || 'badging'
        ).then(() => {
          fileIds.filename.forEach((id) => {
            attachmentIds.push(id.toString());
          });
        });
      }
      if (oldAttachments.length > 0) {
        attachmentIds.push(...oldAttachments);
      }

      return attachmentIds;
    }


    handleSearchForUser = (value) => {
      const { actionSearchUser } = this.props;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        actionSearchUser(value);
      }, 300);
    }

    processInspectionForState = (app) => {
      if (app) {
        const schema = app.answer_schema.fields;
        const { schemaSettings } = this.props;
        let { fieldErrors, requiredMap, response } = this.state;
        const attachmentslistA = getField(schema, 'attachmentslist_a');
        const attachmentslistB = getField(schema, 'attachmentslist_b');
        const attachmentslistC = getField(schema, 'attachmentslist_c');
        schema.forEach((f) => {
          const isDisabled = f.isDisabled || f?.settings?.disable_for_public || f?.internal;
          requiredMap = {
            ...requiredMap,
            [f.id]: isDisabled ? false : f.required
          };
          if (!f.conditional) {
            fieldErrors = {
              ...fieldErrors,
              [f.id]:
                isDisabled
                || Object.keys(f?.default_value || {})?.length !== 0
                  ? false
                  : f.required,
              first_name: app?.first_name ? false : true,
              last_name: app?.last_name ? false : true,
              email: app?.email ? false : true,
              phone_number: app?.phone_number ? false : true,
              nation_of_citizenship: false,
              passport: response?.nation_of_citizenship?.value === 'US' ? false : true,
              passport_country: response?.nation_of_citizenship?.value === 'US' ? false : true,
              alien_registration_number: response?.nation_of_citizenship?.value === 'US' ? false : true,
              employer: app.company_name ? false : true,
              attachmentslist_a:
                (!attachmentslistA?.isDisabled && !attachmentslistA?.settings?.add_req_docs)
                  ? (attachmentslistA?.required === undefined ? false : attachmentslistA?.required)
                  : false,
              attachmentslist_b:
                (!attachmentslistB?.isDisabled && !attachmentslistB?.settings?.add_req_docs)
                  ? (attachmentslistB?.required === undefined ? false : attachmentslistB?.required)
                  : false,
              attachmentslist_c:
                (!attachmentslistC?.isDisabled && !attachmentslistC?.settings?.add_req_docs)
                  ? (attachmentslistC?.required === undefined ? false : attachmentslistC?.required)
                  : false
            };
          } else {
            fieldErrors = {
              ...fieldErrors,
              [f.id]: false
            };
          }
          if (f.type === 'date') {
            fieldErrors = { ...fieldErrors, [f.id]: false };
          }
          const isSinglePage = schemaSettings?.settings?.single_page_application_setup;
          if (this.state.currentStep === 0 && !isSinglePage) {
            fieldErrors = { ...fieldErrors, signature: false };
          }
          if (this.props?.renewalApplicationData && this.props?.renewalApplicationData.length !== 0) {
            fieldErrors = { ...fieldErrors, [f.id]: false };
          }
        });
        this.setState({ requiredMap, fieldErrors });
      }
    };

    handleDropListA = (dropped, required) => {
      const { info } = this.state;
      this.handleAnswerChanged(
        'info',
        [...info.attachments_listA, ...dropped],
        'attachments_listA',
        required
      );
    };

    onDocumentLoadSuccess = (numPages) => {
      this.setState({ numPages });
    };

    renderPages = () => {
      const { numPages } = this.state;
      const pages = [];
      for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
        pages.push(
          <Page
            key={pageNumber}
            pageNumber={pageNumber}
            renderTextLayer={false}
            width={1000}
          />
        );
      }
      return pages;
    };

    handleDropListB = (dropped, required) => {
      const { info } = this.state;
      this.handleAnswerChanged(
        'info',
        [...info.attachments_listB, ...dropped],
        'attachments_listB',
        required
      );
    };

      handleDropListC = (dropped, required) => {
        const { info } = this.state;
        this.handleAnswerChanged(
          'info',
          [...info.attachments_listC, ...dropped],
          'attachments_listC',
          required
        );
      };

    handleDropList = (dropped, list, row) => {
      this.handleAnswerChanged('requiredAttachments', [...dropped], 'attachment', list, row);
    };

    handleRemoveImage = (r, list, row, field) => {
      const { info, requiredAttachments } = this.state;
      const res = requiredAttachments?.[list]?.[row]?.[field].filter(e => e !== r);
      this.handleAnswerChanged('requiredAttachments', res, 'attachment', list, row);
      if (r.id && r.id!==undefined) {
        if (list==='attachments_listA') {
          const removedList = info.removedAttachments_A || [];
          this.handleAnswerChanged('info', [...removedList, r.id], 'removedAttachments_A');
        } else if (list === 'attachments_listB') {
          this.handleAnswerChanged('info', [r.id], 'removedAttachments_B');
        } else if (list === 'attachments_listC') {
          this.handleAnswerChanged('info', [r.id], 'removedAttachments_C');
        }
      }
      };


    handleRemoveImageA = (r, required) => {
      const { info } = this.state;
      const res = info.attachments_listA.filter(e => e !== r);
      this.handleAnswerChanged('info', res, 'attachments_listA', required);
      const removedList = info.removedAttachments_A || [];
      if (r.id && r.id!==undefined) {
        const removedList = info.removedAttachments_B || [];
        this.handleAnswerChanged('info', [...removedList, r.id], 'removedAttachments_B');
      }
    };


    handleRemoveImageB = (r, required) => {
      const { info } = this.state;
      const res = info.attachments_listB.filter(e => e !== r);
      this.handleAnswerChanged('info', res, 'attachments_listB', required);
      const removedList = info.removedAttachments_B || [];
      if (r.id && r.id!==undefined) {
        this.handleAnswerChanged('info', [...removedList, r.id], 'removedAttachments_B');
      }
    };

    handleRemoveImageC = (r, required) => {
      const { info } = this.state;
      const res = info.attachments_listC.filter(e => e !== r);
      this.handleAnswerChanged('info', res, 'attachments_listC', required);
      const removedList = info.removedAttachments_C || [];
      if (r.id && r.id!==undefined) {
        this.handleAnswerChanged('info', [...removedList, r.id], 'removedAttachments_C');
      }
    };

    getFileNames = async (count, airportCode, entity, index) => await GetFileName.getPublicUploadFileName(count, airportCode, entity, index);

    doS3Upload = async (files, fileIds, entity) => {
      const { match, installationId } = this.props;
      const installation = installationId;
      const airportCode = match.params.airportCode;
       return await S3Uploads.uploadFiles(
          files,
          fileIds.filename,
          entity,
          installation,
          airportCode
      );
    };

    initialteApplication = async (draft, paymentInfo) => {
      // eslint-disable-next-line max-len
      const { fieldErrors, info,
        response: { ...form_data },
        signatureFields, multipleRemarks, felonyInvolvingRemarks, noneCheckbox, agreements, additional_info, fields,
        currentStep, application, listAValues, listBValues, listCValues, requiredAttachments } = this.state;
      const { phone, otp, airportCode, user, id, form, schemaSettings } = this.props;
      const errors = { ...fieldErrors };
      const attachmentFields = fields.filter(schemaField => (
        schemaField?.type === 'attachments' && schemaField?.id !== 'attachmentslist_a' && schemaField?.id !== 'attachmentslist_b'
        && schemaField?.id !== 'attachmentslist_c'
      ));

      const attachmentslistA = getField(fields, 'attachmentslist_a');
      const attachmentslistB = getField(fields, 'attachmentslist_b');
      const attachmentslistC = getField(fields, 'attachmentslist_c');

      const checkAddReqdocsA = attachmentslistA?.settings?.add_req_docs;
      const checkAddReqdocsB = attachmentslistB?.settings?.add_req_docs;
      const checkAddReqdocsC = attachmentslistC?.settings?.add_req_docs;

      const isSinglePage = schemaSettings?.settings?.single_page_application_setup;
      if (currentStep === 1 || isSinglePage) {
        if ((application && application?.checkbox_section === true || form?.settings?.checkbox_section === true)) {
          const check = Object.values(additional_info[0]?.multipleRemarks || []).includes(true)
          || Object.values(additional_info[0]?.felonyInvolvingRemarks || []).includes(true);
          if (check === true || (additional_info && additional_info[0]?.noneCheckbox === true)) {
            this.setState({ checkboxSectionError: false });
          } else {
            this.setState({ checkboxSectionError: true, showFormErrors: true });
            return;
          }
        }
        const signatureCheck = fields?.filter(fil => fil.id === 'signature' && !fil?.isDisabled);
        if ((signatureCheck && Object.keys(signatureCheck).length > 0 && !signatureCheck[0].isDisabled)
            && this.state.response?.signature.length === 0) {
          this.setState({ fieldErrors: { ...fieldErrors, signature: true }, showFormErrors: true });
          return;
        // eslint-disable-next-line no-else-return
        } else {
          this.setState({ fieldErrors: { ...fieldErrors, signature: false } });
        }
      }
      let noErrors = Object.keys(errors)
        .every(k => (errors[k] === false));
      let data = {};
      if (draft === true) {
        data.draft=true;
        data.status = 3;
        info.status = 3;
        this.setState({ info });
        noErrors= true;
      } else {
        data.status = 0;
        info.status = 0;
        this.setState({ info });
      }
      if (noErrors) {
        this.setState({ loadingStatus: true });
        if (attachmentFields.length > 0) {
          for (let index = 0; index < attachmentFields.length; index++) {
            let attachmentField = attachmentFields[index]?.id;
            const schemaField = attachmentFields[index];
            if (schemaField?.type === 'attachments') {
              if (schemaField?.type === 'attachments' && form_data[attachmentField]?.length > 0) {
                let attachmentIDs = [];
                const newAttachments = form_data[attachmentField].filter(file => !file.id) || [];
                const oldAttachmentIds = form_data[attachmentField].filter(file => file.id && file.file_name).map(file => file.attachment_id) || [];
                attachmentIDs = [...oldAttachmentIds];
                let customAttachments = '';
                if (newAttachments?.length > 0) {
                  // eslint-disable-next-line no-await-in-loop
                  customAttachments = await this.getFileNames(newAttachments?.length, airportCode, 'badging');
                }
                if (customAttachments) {
                  // eslint-disable-next-line no-await-in-loop
                  await this.doS3Upload(newAttachments, customAttachments, 'badging').then(
                    () => {
                      customAttachments.filename.forEach((attachmentId) => {
                        if (attachmentId) {
                          attachmentIDs.push(attachmentId.toString());
                        }
                      });
                    }
                  );
                data.airportCode = this.props.match.params.airportCode;
                }
                form_data[attachmentField] = attachmentIDs;
              }
            }
          }
        }
        delete additional_info[0]?.checkedMultipleValues;
        delete additional_info[0]?.felonyCheckedValues;
        data.submitted_date =moment().format();
        data.response = form_data;
        data.phone =phone[0] + phone.slice(1).replace(/[^\d]/g, '');
        data.otp =otp;
        data.id = id;
        data.company_name = user.current_tenant?.id;
        data.attachments_listA=[];
        data.attachments_listB=[];
        data.attachments_listC=[];
        data.additional_info = additional_info;
        data.multipleRemarks = multipleRemarks;
        data.felonyInvolvingRemarks = felonyInvolvingRemarks;
        data.noneCheckbox = noneCheckbox;
        data.agreements = agreements;
        data.suffix = info?.suffix;
        data.payment_info = {
          id: paymentInfo?.tokenDetails?.token?.id,
          amount: paymentInfo?.amount
        };
        delete data.feet;
        delete data.inches;
        if (draft === true) {
          data.draft=true;
          data.status = 3;
          info.status = 3;
          this.setState({ info });
        } else {
          data.status = 0;
          info.status = 0;
          this.setState({ info });
        }
        let newAttachmentsA = [];
        let newAttachmentsB = [];
        let newAttachmentsC = [];
        let oldAttachmentIdsA = [];
        let oldAttachmentIdsB = [];
        let oldAttachmentIdsC = [];
        if (info.attachments_listA && info.attachments_listA.length > 0) {
          newAttachmentsA = info.attachments_listA.filter(file => !file.id);
          oldAttachmentIdsA = info.attachments_listA.filter(file => file.id && file.file_name).map(file => file.attachment_id);
        }
        if (info.attachments_listB && info.attachments_listB.length > 0) {
          newAttachmentsB = info.attachments_listB.filter(file => !file.id);
          oldAttachmentIdsB = info.attachments_listB.filter(file => file.id && file.file_name).map(file => file.attachment_id);
        }
        if (info.attachments_listC && info.attachments_listC.length > 0) {
          newAttachmentsC = info.attachments_listC.filter(file => !file.id);
          oldAttachmentIdsC = info.attachments_listC.filter(file => file.id && file.file_name).map(file => file.attachment_id);
        }
        const forms_of_identification = { ...requiredAttachments };

        let fileIdsA = '';
        let fileIdsB = '';
        let fileIdsC = '';

      const processAttachments = async (list, attachments, value) => {
        const attachmentsIds = [];
        let fieldIds = {};

        await Promise.all(
          Object.keys(forms_of_identification[list]|| {}).map(async (eachRow, index) => {
            const { attachment, file_name, expiry_date } = forms_of_identification[list][eachRow];

            if (attachment?.length > 0) {
              const newAttachments = attachment.filter(file => !file.id);
              const oldAttachmentIds = attachment.filter(file => file.id && file.file_name).map(file => file.attachment_id);

              let fileIds = '';

              if (newAttachments.length>0) {
                attachments.push(...newAttachments);
                 fileIds = await this.getFileNames(newAttachments.length, airportCode, list ==='attachments_listA'? 'badgingListA': list === 'attachments_listB' ? 'badgingListB' : 'badgingListC', index);
                 attachmentsIds.push(...(fileIds?.filename));
              }

                  forms_of_identification[list][eachRow] = {
                    file_name: value.find(eachKey => eachKey.key === file_name),
                    expiry_date,
                    attachment: oldAttachmentIds?.length>0 ? oldAttachmentIds : fileIds?.filename
                  };
            } else {
              forms_of_identification[list][eachRow] = {
                file_name: value.find(eachKey => eachKey.key === file_name),
                expiry_date,
                attachment: []
              };
            }
          })
        );

          fieldIds.filename = attachmentsIds;
        if (list === 'attachments_listA') {
            fileIdsA = fieldIds;
        }
        if (list === 'attachments_listB') {
          fileIdsB = fieldIds;
        }
        if (list === 'attachments_listC') {
          fileIdsC = fieldIds;
        }
    };

      if (checkAddReqdocsA) {
        await processAttachments('attachments_listA', newAttachmentsA, listAValues);
      } else {
          let attachmentsA = [];
            oldAttachmentIdsA.forEach((attachmentId) => {
              attachmentsA.push(attachmentId.toString());
          });
          form_data.attachments_listA = attachmentsA;
      }

      if (checkAddReqdocsB) {
        await processAttachments('attachments_listB', newAttachmentsB, listBValues);
      } else {
          let attachmentsB = [];
          oldAttachmentIdsB.forEach((attachmentId) => {
            attachmentsB.push(attachmentId.toString());
        });
          form_data.attachments_listB = attachmentsB;
      }

      if (checkAddReqdocsC) {
        await processAttachments('attachments_listC', newAttachmentsC, listCValues);
      } else {
          let attachmentsC = [];
          oldAttachmentIdsC.forEach((attachmentId) => {
            attachmentsC.push(attachmentId.toString());
        });
          form_data.attachments_listC = attachmentsC;
      }

      data.forms_of_identification = { ...forms_of_identification };

        if (!checkAddReqdocsA && newAttachmentsA.length > 0) {
          fileIdsA = await this.getFileNames(newAttachmentsA.length, airportCode, 'badgingListA');
        }
        if (!checkAddReqdocsB && newAttachmentsB.length > 0) {
          fileIdsB = await this.getFileNames(newAttachmentsB.length, airportCode, 'badgingListB');
        }
        if (!checkAddReqdocsC && newAttachmentsC.length > 0) {
          fileIdsC = await this.getFileNames(newAttachmentsC.length, airportCode, 'badgingListC');
        }
        if (fileIdsA || fileIdsB || fileIdsC) {
          if (fileIdsA) {
            await this.doS3Upload(newAttachmentsA, fileIdsA, 'badging').then(() => {
              fileIdsA.filename.forEach((attachmentId) => {
                data.attachments_listA.push(attachmentId.toString());
              });
            });
            data.airportCode = this.props.match.params.airportCode;
          }
          if (fileIdsB) {
            await this.doS3Upload(newAttachmentsB, fileIdsB, 'badging').then(() => {
              fileIdsB.filename.forEach((attachmentId) => {
                data.attachments_listB.push(attachmentId.toString());
              });
            });
            data.airportCode = this.props.match.params.airportCode;
          }
          if (fileIdsC) {
            await this.doS3Upload(newAttachmentsC, fileIdsC, 'badging').then(() => {
              fileIdsC.filename.forEach((attachmentId) => {
                data.attachments_listC.push(attachmentId.toString());
              });
            });
            data.airportCode = this.props.match.params.airportCode;
          }
        }
        if (signatureFields.length > 0) {
          for (var i = 0; i < signatureFields.length; i++) {
            const signatureField = signatureFields[i];
            if (data.response[signatureField]) {
              let fileIds = '';
              let signatureData = [];
              signatureData.push(data.response[signatureField]);
              fileIds = await this.getFileNames(1, airportCode, 'badging');
              if (fileIds) {
                  await this.doS3Upload(
                    signatureData,
                    fileIds,
                    'badging'
                  );
                  data.response[signatureField] = [fileIds.filename.toString()];
                }
              }
            }
          }
          if (info.removedAttachments_A && info.removedAttachments_A.length > 0) {
            data= {
              ...data,
              removedAttachments_A: info.removedAttachments_A
            };
          }
          if (info.removedAttachments_B && info.removedAttachments_B.length > 0) {
            data= {
              ...data,
              removedAttachments_B: info.removedAttachments_B
            };
          }
          if (info.removedAttachments_C && info.removedAttachments_C.length > 0) {
            data= {
              ...data,
              removedAttachments_C: info.removedAttachments_C
            };
          }
        if (
          'removedAttachments' in info
          && info?.removedAttachments?.length > 0
        ) {
          data.removedAttachments = info.removedAttachments;
        } else {
        try {
          await fetch(`${this.publicUrl}/badging/create_badge/${airportCode}`, {
              method: 'POST',
              body: JSON.stringify(data),
              headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json())
            .then((data) => {
              if (data.errors) {
                this.setState({
                  loadingStatus: false
                });
                toast.error('Payment failed');
              } else {
                this.setState({
                  message: 'Your Badge Application entry has been submitted successfully.',
                  createApiStatus: true,
                  loadingStatus: false,
                  badge_data: data
                });
              }
            });
        } catch (error) {
          let message = 'There was a problem while submitting the form';
          if (error && error.detail) message = error.detail;
          this.setState({
            message,
            apiStatus: true,
            loadingStatus: false
          });
        }
        localStorage.removeItem('currentPage');
      }
      } else {
        this.setState({ showFormErrors: true });
      }
  }


  prev = () => {
    const { currentStep, fieldErrors } = this.state;
    this.setState({
      currentStep: currentStep - 1,
      fieldErrors: {
        ...fieldErrors,
        signature: false
      }
    });
    window.scrollTo(0, 0);
  }

  next = () => {
    const {
      currentStep,
      fieldErrors,
      response,
      info,
      fields,
      additional_info,
      requiredAttachmentsErrors
    } = this.state;

    const { form, schemaSettings } = this.props;

    const isSinglePage = schemaSettings?.settings?.single_page_application_setup;

    // helper fix
    const isFormValid = (errorsObj = {}) => {
      if (!errorsObj || Object.keys(errorsObj).length === 0) return false;
      return Object.values(errorsObj).every(v => v === false);
    };

    if (currentStep === 0 || isSinglePage) {
      let updatedFieldErrors = { ...fieldErrors };

      // avoid multiple setState overrides
      if (!isSinglePage) {
        updatedFieldErrors.signature = false;
      }

      if (response.nation_of_citizenship?.value === 'US') {
        updatedFieldErrors = {
          ...updatedFieldErrors,
          nation_of_citizenship: false,
          alien_registration_number: false,
          passport: false,
          passport_country: false
        };
      }

      if (response.employer) {
        updatedFieldErrors.employer = false;
      }

      const listA = getField(fields, 'attachmentslist_a');
      const listB = getField(fields, 'attachmentslist_b');
      const listC = getField(fields, 'attachmentslist_c');

      const checkReqAttachementError = list => Object.values(requiredAttachmentsErrors[list] || {}).every(row => Object.values(row || {}).every(value => value === false));

      let reqAttachmentListAError = true;
      let reqAttachmentListBError = true;
      let reqAttachmentListCError = true;

      const dob_setting = fields.filter(field => field.id === 'date_of_birth');
      const country = fields.filter(field => field.id === 'country');

      if (country.length > 0 && !country[0]?.isDisabled) {
        updatedFieldErrors.country = false;
      }

      let newDate = moment().startOf('day');
      let dateOfBirth = moment(response?.date_of_birth);
      let age = newDate.diff(dateOfBirth, 'year', true);

      // DOB validation
      if (
        dob_setting.length > 0
        && !dob_setting[0]?.isDisabled
        && response?.date_of_birth
        && age <= 18
      ) {
        this.setState({
          dateError: 'Applicant age should be 18 years or above.'
        });
        return;
      }

      // Attachments
      if (!listA?.isDisabled && listA?.required) {
        if (!listA?.settings?.add_req_docs && info?.attachments_listA?.length === 0) {
          this.setState({ attachmentslist_a: true, showFormErrors: true });
          return;
        }
      }

      if (!listB?.isDisabled && listB?.required) {
        if (!listB?.settings?.add_req_docs && info?.attachments_listB?.length === 0) {
          this.setState({ attachmentslist_b: true, showFormErrors: true });
          return;
        }
      }

      if (!listC?.isDisabled && listC?.required) {
        if (!listC?.settings?.add_req_docs && info?.attachments_listC?.length === 0) {
          this.setState({ attachmentslist_c: true, showFormErrors: true });
          return;
        }
      }

      if (listA?.required && listA?.settings?.add_req_docs) {
        reqAttachmentListAError = checkReqAttachementError('attachments_listA');
      }

      if (listB?.required && listB?.settings?.add_req_docs) {
        reqAttachmentListBError = checkReqAttachementError('attachments_listB');
      }

      if (listC?.required && listC?.settings?.add_req_docs) {
        reqAttachmentListCError = checkReqAttachementError('attachments_listC');
      }

      let noErrors = isFormValid(updatedFieldErrors);

      if (noErrors) {
        noErrors = reqAttachmentListAError
          && reqAttachmentListBError
          && reqAttachmentListCError;
      }

      // ======================
      // Step1 validation in single page
      // ======================
      if (isSinglePage && noErrors) {
        const { application } = this.state;

        if (
          (application && application?.checkbox_section === true)
          || form?.settings?.checkbox_section === true
        ) {
          const check = Object.values(additional_info?.[0]?.multipleRemarks || []).includes(true)
            || Object.values(additional_info?.[0]?.felonyInvolvingRemarks || []).includes(true);

          if (!(check || additional_info?.[0]?.noneCheckbox === true)) {
            this.setState({
              checkboxSectionError: true,
              showFormErrors: true
            });
            return;
          }
        }

        const signature_type = fields?.filter(
          fil => fil.id === 'signature' && !fil?.isDisabled
        );

        if (
          signature_type?.length > 0
          && (!response?.signature || response.signature.length === 0)
        ) {
          this.setState({
            fieldErrors: { ...updatedFieldErrors, signature: true },
            showFormErrors: true
          });
          return;
        }
      }

      if (noErrors) {
        this.setState(prevState => ({
          currentStep: isSinglePage
            ? 1
            : Math.min(4, prevState.currentStep + 1),
          showFormErrors: false,
          fieldErrors: updatedFieldErrors,
          response: { ...response },
          dateError: ''
        }));
        window.scrollTo(0, 0);
      } else {
        this.setState({
          fieldErrors: updatedFieldErrors,
          showFormErrors: true,
          dateError: false
        });
      }
    } else if (currentStep === 1) {
      const { application } = this.state;

      if (
        (application && application?.checkbox_section === true)
        || form?.settings?.checkbox_section === true
      ) {
        const check = Object.values(additional_info?.[0]?.multipleRemarks || []).includes(true)
          || Object.values(additional_info?.[0]?.felonyInvolvingRemarks || []).includes(true);

        if (!(check || additional_info?.[0]?.noneCheckbox === true)) {
          this.setState({
            checkboxSectionError: true,
            showFormErrors: true
          });
          return;
        }
      }

      const signature_type = fields?.filter(
        fil => fil.id === 'signature' && !fil?.isDisabled
      );

      if (
        signature_type?.length > 0
        && (!response?.signature || response.signature.length === 0)
      ) {
        this.setState({
          fieldErrors: { ...fieldErrors, signature: true },
          showFormErrors: true
        });
        return;
      }

      const noErrors = isFormValid(fieldErrors);

      if (noErrors) {
        this.setState(prevState => ({
          currentStep: Math.min(4, prevState.currentStep + 1),
          showFormErrors: false,
          response: { ...response }
        }));
      } else {
        this.setState({ showFormErrors: true });
      }
    } else {
      this.setState({
        currentStep: Math.max(1, currentStep + 1)
      });
    }
  };

  getConfig = () => {
    AWS.config.update({
      region: process.env.REACT_APP_REGION
    });
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
    });
    return AWS.config.credentials.getPromise();
  };

  getData = (fileName) => {
    const { match: { params: { installationId } } } = this.props;
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : installationId}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ successMessage: info });
    }).catch(() => {
      this.setState({ successMessage: '' });
    });
  };

  getPrivacyMessageData = (fileName) => {
    const { match: { params: { installationId } } } = this.props;
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : installationId}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ privacyMessage: info });
    }).catch(() => {
      this.setState({ privacyMessage: '' });
    });
  };


  getListAMessageData = (fileName) => {
    const { match: { params: { installationId } } } = this.props;
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : installationId}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ listAMessage: info });
    }).catch(() => {
      this.setState({ listAMessage: '' });
    });
  };

  getListBMessageData = (fileName) => {
    const { match: { params: { installationId } } } = this.props;
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : installationId}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ listBMessage: info });
    }).catch(() => {
      this.setState({ listBMessage: '' });
    });
  };

  getListCMessageData = (fileName) => {
    const { match: { params: { installationId } } } = this.props;
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01'
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : installationId}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ listCMessage: info });
    }).catch(() => {
      this.setState({ listCMessage: '' });
    });
  };

  getApplicantAcknowldgementMessageData = (fileName) => {
    const { match: { params: { installationId } } } = this.props;
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : installationId}-attachments/conditions/badging`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(undefined);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ applicantAcknowldgementMessage: info });
    }).catch(() => {
      this.setState({ applicantAcknowldgementMessage: '' });
    });
  };

  handleAddAction = async () => {
    const { match: { params: { id, airportCode } } } = this.props;
    const { info } = this.state;
    const data = {
      terms: {
        terms_and_conditions: true,
        accepted_by: info?.first_name,
        accepted_on: new Date()
      }
    };
    try {
      await fetch(`${this.publicUrl}/badging/terms_and_conditions/${id}/${airportCode}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'application/json' }
        })
        .then(response => response.json())
        .then((data) => {
          this.setState({
            message: 'Terms and Conditions accepted successfully.',
            loadingStatus: false
          });
        });
    } catch (error) {
      let message = 'There was a problem while submitting the terms and conditions';
      if (error && error.detail) message = error.detail;
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
    }
    this.setState({
      info: {
        ...info,
        terms: true
      },
      showIn: false
    });
  }

  handlePayment = (response) => {
    this.initialteApplication(false, response);
  }

  handlePdfPages = (value) => {
    const { pdfPageNumber, totalPdfPages } = this.state;
    if (value) {
      if (totalPdfPages !== pdfPageNumber) {
        this.setState({ pdfPageNumber: pdfPageNumber + 1 });
      }
    } else if (pdfPageNumber > 1) {
        this.setState({ pdfPageNumber: pdfPageNumber - 1 });
      }
  };

  render() {
    const {
      info, requiredMap, answers, showFormErrors, response, fields, loadingStatus, currentStep, additional_info, fieldErrors, showIn, privacyMessage, pdfUrl, application, listAError,
      listBError, listAMessage, listBMessage, applicantAcknowldgementMessage, listAValues, listBValues, listCValues, requiredAttachmentsErrors, app, dateError, checkboxSectionError, requiredAttachments,
      listCError, listCMessage } = this.state;
    const { form, airportCode, schemaSettings, renewalApplicationData, user } = this.props;
    const pdfData = schemaSettings?.settings?.privacy_pdf_attachments?.map(e => e);
    const pdfHost = window.location.hostname.replace(/^.{6}/g, 'us');
    let showSubmitBtn = false;
    let showNextBtn = false;

    const isSinglePage = schemaSettings?.settings?.single_page_application_setup;
    const hasPayment = (!renewalApplicationData && schemaSettings?.settings?.badge_payment_section === true)
      || (renewalApplicationData && schemaSettings?.settings?.renewal_payment === true);
      const isOnPaymentStep = (!isSinglePage && currentStep === 2 && hasPayment)
      || (isSinglePage && currentStep === 1 && hasPayment);

    // CASE 1: SINGLE PAGE FLOW
    if (isSinglePage) {
      if (hasPayment && currentStep === 0) {
        // Step 0 → go to payment
        showNextBtn = true;
        showSubmitBtn = false;
      } else {
        // Final step (either no payment OR already on payment)
        showNextBtn = false;
        showSubmitBtn = true;
      }
    } else if (
      schemaSettings?.settings?.badge_payment_section
      && (currentStep === 0 || currentStep === 1)
      && (renewalApplicationData === undefined || renewalApplicationData === null)
    ) {
      showNextBtn = true;
      showSubmitBtn = false;
    } else if (
      schemaSettings?.settings?.renewal_payment
      && renewalApplicationData
      && (currentStep === 0 || currentStep === 1)
    ) {
      showNextBtn = true;
      showSubmitBtn = false;
    } else if (currentStep === 0) {
      showNextBtn = true;
      showSubmitBtn = false;
    } else if (currentStep === 1) {
      showNextBtn = false;
      showSubmitBtn = true;
    }
    if (isOnPaymentStep) {
      showSubmitBtn = false;
      showNextBtn = false;
    }
    return (
      <>
        <Loading loadingStatus={loadingStatus} />
        <div className={styles.newlog}>
          <div className={styles.form}>
            <Panel
              title="asset_registry.create.Application"
              defaultTitle="New Badge Application"
            >
            <div className={`${styles.content} ${styles.embedded}`}>
          {/* <div className={styles.draft}>
          <Button onClick={()=>this.initialteApplication(true)} translationID="badging.form.draft"
          defaultText="Save as draft" action="secondary"
          />
        </div> */}
        {currentStep === 0 && currentStep === 1 && (
              <ProgressBar step={currentStep} />
        )}
        {(isSinglePage || currentStep === 0) && (
              <Step0
              goToNext={this.next}
              info={info}
              handleAnswerChanged={this.handleAnswerChanged}
              handleFieldErrorChanged={this.handleFieldErrorChanged}
              requiredMap={requiredMap}
              fields={fields}
              response={response}
              listAError={listAError}
              listBError={listBError}
              listCError={listCError}
              handleDropListA={this.handleDropListA}
              handleDropListB={this.handleDropListB}
              handleDropListC={this.handleDropListC}
              handleRemoveImageA={this.handleRemoveImageA}
              handleRemoveImageB={this.handleRemoveImageB}
              handleRemoveImageC={this.handleRemoveImageC}
              showFormErrors={showFormErrors}
              showFieldErrors={showFormErrors}
              fieldErrors={fieldErrors}
              airportCode={airportCode}
              pdfUrl={pdfUrl}
              handleAddmore={this.handleAddmore}
              requiredAttachments={requiredAttachments || {}}
              requiredAttachmentsErrors={requiredAttachmentsErrors || {}}
              listAValues={listAValues}
              listBValues={listBValues}
              listCValues={listCValues}
              handleRemoveImage={this.handleRemoveImage}
              handleDropList={this.handleDropList}
              handleUploadAttachments={this.handleUploadAttachments}
              pdfHost={pdfHost}
              schemaSettings={schemaSettings?.settings}
              listAMessage={listAMessage}
              listBMessage={listBMessage}
              listCMessage={listCMessage}
              applicantAcknowldgementMessage={applicantAcknowldgementMessage}
              tenantName={[app?.company_name]}
              renewalApplicationData={renewalApplicationData}
              />
        )}

        {(isSinglePage || (!isSinglePage && currentStep === 1)) && (
              <Step1
              goToNext={this.next}
              handleAnswerChanged={this.handleAnswerChanged}
              handleFieldErrorChanged={this.handleFieldErrorChanged}
              requiredMap={requiredMap}
              fields={fields}
              response={response}
              form={form}
              additional_info={additional_info}
              showFormErrors={showFormErrors}
              showFieldErrors={showFormErrors}
              fieldErrors={fieldErrors}
              applicationData={application}
              renewalApplicationData={renewalApplicationData}
              checkboxSectionError={checkboxSectionError}
              />
        )}

        {(
        (!isSinglePage && currentStep === 2) || (isSinglePage && currentStep === 1)
          ) && hasPayment && (
            <Step2
              goToNext={this.next}
              schemaSettings={schemaSettings}
              handlePayment={this.handlePayment}
              profileCurrency={user?.portal_airport?.airport_settings?.currency || '$'}
              airportSettings={form?.airport_data}
            />
          )}
                <div className={styles.footer}>
                {currentStep !== 0 && (
                  <Button
                  action="tertiary"
                  onClick={this.prev}
                  translationID="hazard.new.back"
                  defaultText="Back"
                  />
                )}
              {/* <Button onClick={()=>this.initialteApplication(true)} translationID="badging.form.draft"
              defaultText="Save as draft" action="secondary"
              /> */}
                {showNextBtn && (
                  <div style={{ marginLeft: currentStep !== 0 ? '0px': '673px' }}>
                    <p className="text-danger text-center mb-0 mt-0 mr-4">
                      {dateError}
                    </p>
                    <Button
                      action="secondary"
                      onClick={this.next}
                      translationID="hazards.new.nexts"
                      defaultText="Continue to Next Step"
                    />
                  </div>
                )}
                {showSubmitBtn && (
                  <div style={
                    schemaSettings?.settings?.single_page_application_setup
                      ? { width: '100%', display: 'flex', justifyContent: 'center' }
                      : {}
                  }
                  >
                    <Button onClick={this.initialteApplication} translationID="wildlife.form.1" className={'float-center mt-2 mb-2 mr-4'}
                      defaultText="Submit" action="secondary"
                    />
                  </div>
                )}
                </div>
            </div>
            </Panel>
          </div>
        </div>
      {application && !application?.terms_and_conditions_details?.accepted_by && (
      <Modal showIn={showIn} width="auto" disableOutsideClick>
          <>
            <div style={{ borderBottom: '1px solid #e6eaee' }}>
              <div style={{ margin: '20px 15px 20px 15px' }}>
                <div className={styles.termstitle}>
                  <h3 style={{ fontSize: '19px' }}>Privacy Act Notice</h3>
                </div>
              </div>
            </div>
            <div style={{ borderBottom: '1px solid #e6eaee', height: '500px', overflow: 'auto' }}>
              {privacyMessage.length > 0 && (
                <div dangerouslySetInnerHTML={{ __html: privacyMessage }} style={{ margin: '20px' }} />
              )}
              <div>
              {pdfData?.map(ele => (
                <DisplayPDF url={ele?.url} />
                ))}
              </div>
            </div>
            <div style={{ margin: '20px', float: 'right' }}>
              <Button
                onClick={this.handleAddAction}
                translationID="todo.newTask.save1"
                defaultText="Accept & Continue"
                action="secondary"
              />
            </div>
          </>
      </Modal>
      )}
      </>
      );
    }
    }

ApplicationForm.propTypes = {
  match: PropTypes.shape({}).isRequired,
  actionUpdateCurrentPage: PropTypes.func,
  profile: PropTypes.shape({}).isRequired,
  actionFetchUserProfile: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  currentModule: state.general.currentModule,
  user: state.auth.profile,
  users: state.inspection.userlist,
  Tenants: state.lease.TenantLookupData,
  saveAction: state.badging.InitiateApplicationAction,
  allDataSources: state.inspection.allDataSources,
  schema: state.badging.schema,
  translations: state.auth.translations
});

export default connect(
  mapStateToProps
)(injectIntl(withRouter(ApplicationForm)));
